package com.sweetlime.dungeonamigo.model

enum class Condition(
    val displayName: String,
    val emoji: String,
    val shortDescription: String,
) {
    BLINDED("Blinded", "👁️", "Can't see, auto-fails sight checks"),
    CHARMED("Charmed", "💕", "Can't attack charmer, charmer has advantage on social checks"),
    DEAFENED("Deafened", "👂", "Can't hear, auto-fails hearing checks"),
    EXHAUSTION("Exhaustion", "😴", "Cumulative debuffs by level"),
    FRIGHTENED("Frightened", "😱", "Disadvantage on checks/attacks while source is visible"),
    GRAPPLED("Grappled", "🤝", "Speed becomes 0"),
    INCAPACITATED("Incapacitated", "💤", "Can't take actions or reactions"),
    INVISIBLE("Invisible", "👻", "Impossible to see without special senses"),
    PARALYZED("Paralyzed", "⚡", "Incapacitated, auto-fails STR/DEX saves"),
    PETRIFIED("Petrified", "🗿", "Turned to stone, incapacitated"),
    POISONED("Poisoned", "🤢", "Disadvantage on attacks and ability checks"),
    PRONE("Prone", "⬇️", "Disadvantage on attacks, melee hits have advantage"),
    RESTRAINED("Restrained", "🔗", "Speed 0, disadvantage on attacks and DEX saves"),
    STUNNED("Stunned", "⭐", "Incapacitated, auto-fails STR/DEX saves"),
    UNCONSCIOUS("Unconscious", "💀", "Incapacitated, prone, auto-fails STR/DEX saves"),
}